<!-- Ported from the Polaris kit: src/product/components/RadioCardGroup.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand change (phase P): `id` defaults to a useId() prefix (the kit's fixed 'radio-cards' repeated ids when two
     groups share a page). `has-data-[state=checked]:` is `has-[[data-state=checked]]:` (porter rule 13). -->
<script setup>
// A set of options where each is a card: a title, a sentence, and a radio. The chosen one has a neutral fill and a stronger border (the
// selection is never a color). Built on the registry radio group, so the arrows move between cards and one is always reachable by Tab.
import { computed, useId } from 'vue';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Label } from '../ui/label';

const props = defineProps({
  options: { type: Array, required: true }, // [{ value, title, description?, disabled? }]
  label: { type: String, required: true }, // what is being chosen, for a screen reader
  id: { type: String, default: '' }, // prefix of the items' ids; unique by default
});
const model = defineModel({ type: String, default: '' });
const uid = useId();
const prefix = computed(() => props.id || `radio-cards-${uid}`);
</script>

<template>
  <RadioGroup
    v-model="model"
    :aria-label="label"
    class="grid gap-2 sm:grid-cols-2"
    data-radio-cards
  >
    <Label
      v-for="option in options"
      :key="option.value"
      :for="`${prefix}-${option.value}`"
      class="flex cursor-pointer items-start gap-3 rounded-polaris-lg border border-solid border-polaris-border p-4 font-normal transition-colors hover:bg-polaris-accent has-[[data-state=checked]]:border-polaris-foreground/40 has-[[data-state=checked]]:bg-polaris-selected has-[[data-state=checked]]:text-polaris-selected-foreground"
      :class="option.disabled ? 'pointer-events-none opacity-50' : ''"
    >
      <RadioGroupItem
        :id="`${prefix}-${option.value}`"
        :value="option.value"
        :disabled="option.disabled"
        class="mt-0.5"
      />
      <span class="grid gap-0.5">
        <span class="type-polaris-card-title">{{ option.title }}</span>
        <span
          v-if="option.description"
          class="type-polaris-body text-polaris-muted-foreground"
        >
          {{ option.description }}
        </span>
      </span>
    </Label>
  </RadioGroup>
</template>
